import revive_payload_client_4sVQNw7RlN from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/home/runner/_work/jbg-web/jbg-web/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import siteConfig_JRId4KOeUL from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/siteConfig.js";
import inferSeoMetaPlugin_JSh5nGhzCz from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/inferSeoMetaPlugin.js";
import titles_eoILE7jqvj from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/titles.js";
import defaultsWaitI18n_lla9AZgoHk from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/defaultsWaitI18n.js";
import plugin_iGLjBbor9q from "/home/runner/_work/jbg-web/jbg-web/node_modules/nuxt-jsonld/dist/runtime/plugin.js";
import plugin_tbFNToZNim from "/home/runner/_work/jbg-web/jbg-web/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_42RIGIx6e8 from "/home/runner/_work/jbg-web/jbg-web/node_modules/@nuxt/image/dist/runtime/plugin.js";
import switch_locale_path_ssr_5csfIgkrBP from "/home/runner/_work/jbg-web/jbg-web/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/home/runner/_work/jbg-web/jbg-web/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import cms_BHquPmbZ2Y from "/home/runner/_work/jbg-web/jbg-web/src/plugins/cms.ts";
import plugin_8QVB3NKHAg from "/home/runner/_work/jbg-web/jbg-web/src/plugins/i18n/plugin.ts";
import plugin_vACT9eUuhN from "/home/runner/_work/jbg-web/jbg-web/src/plugins/modal/plugin.ts";
import plugin_HVs6w4F52v from "/home/runner/_work/jbg-web/jbg-web/src/plugins/toast/plugin.ts";
import auth_e0FkfVuy48 from "/home/runner/_work/jbg-web/jbg-web/src/plugins/auth.ts";
import bb_YU6Mjhk1sr from "/home/runner/_work/jbg-web/jbg-web/src/plugins/bb.ts";
import gamestream_EnR6dotPKP from "/home/runner/_work/jbg-web/jbg-web/src/plugins/gamestream.ts";
import listrak_PXBAUPe2D6 from "/home/runner/_work/jbg-web/jbg-web/src/plugins/listrak.ts";
import md_ZFs2Fid4ui from "/home/runner/_work/jbg-web/jbg-web/src/plugins/md.ts";
import params_ohy56fInFf from "/home/runner/_work/jbg-web/jbg-web/src/plugins/params.ts";
import report_7BcPqal8tQ from "/home/runner/_work/jbg-web/jbg-web/src/plugins/report.ts";
import select_fkZYP3esEZ from "/home/runner/_work/jbg-web/jbg-web/src/plugins/select.ts";
import shopify_DGWO89xc9t from "/home/runner/_work/jbg-web/jbg-web/src/plugins/shopify.ts";
import user_pRMZBFhYe6 from "/home/runner/_work/jbg-web/jbg-web/src/plugins/user.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  siteConfig_JRId4KOeUL,
  inferSeoMetaPlugin_JSh5nGhzCz,
  titles_eoILE7jqvj,
  defaultsWaitI18n_lla9AZgoHk,
  plugin_iGLjBbor9q,
  plugin_tbFNToZNim,
  plugin_42RIGIx6e8,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  cms_BHquPmbZ2Y,
  plugin_8QVB3NKHAg,
  plugin_vACT9eUuhN,
  plugin_HVs6w4F52v,
  auth_e0FkfVuy48,
  bb_YU6Mjhk1sr,
  gamestream_EnR6dotPKP,
  listrak_PXBAUPe2D6,
  md_ZFs2Fid4ui,
  params_ohy56fInFf,
  report_7BcPqal8tQ,
  select_fkZYP3esEZ,
  shopify_DGWO89xc9t,
  user_pRMZBFhYe6
]